/*
 * @Author: Jhonsem
 * @Date: 2018-12-04 11:10:00
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2018-12-13 11:35:39
 */

import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import generalUtilsHelper from "@/utils/generalUtils";
import Vue from "vue";
import BakcPress from "@/utils/backPress";
import { DIALOG_KEY, ACTION_SHEET_KEY } from "@/utils/backPress";
import vipClock from "@/views/vipCenter/VipDialogClock.vue";
import { remoteImg } from "@/plugins/resPlugin";
import dialogTopContent from "@/components/dialog/topPicContent/topPicContent";

const actions: ActionTree<any, any> = {
  async [types.DIALOG_SHOW](
    { state, commit, dispatch, rootState },
    payLoad: any
  ) {
    try {
      console.log("DIALOG_CONFIRM_ORDER payLoad:", payLoad);
      const {
        id,
        title,
        size,
        topContent,
        topIcon,
        midContent,
        buttons,
        cancelFn,
        countTime,
        delayFn,
        closeImgShow, //关闭的按钮图片是否显示
        backPressFn,
        bottomContent,
        topIconRadius, // 百分比: 20 => 20%
        clock,
        textCountDown, // 倒计时是数字文字倒数到0 默认是 false
        countDwonFn
      } = payLoad;
      let instance: any;
      let timer: any;
      let countDownIntearval: any;
      const classId = id ? "__classid__" + id : "dialog-container";
      const dialogRef: any = Vue.extend({
        components: {
          vipClock
        },
        data() {
          return {
            countDownValue: 0
          };
        },
        methods: {
          hideDialog() {
            const el: any = document.getElementsByClassName(classId)[0];
            instance.$destroy();
            if (el && el.parentNode) {
              el.parentNode.removeChild(el);
            }
            clearTimeout(timer);
            clearInterval(countDownIntearval);
            BakcPress.destroy(DIALOG_KEY);
          },
          clickMask() {
            if (this.closeImgShow !== false) {
              return;
            }
            this.hideDialog();
            cancelFn === undefined ? null : cancelFn();
          },
          clickColse() {
            this.hideDialog();
            cancelFn === undefined ? null : cancelFn();
          },
          clickButton(button: any) {
            this.hideDialog();
            button.clickFn === undefined ? null : button.clickFn();
          }
        },
        destroyed() {
          this.hideDialog();
        },
        mounted() {
          console.log("backPressFn", backPressFn);
          BakcPress.listen({
            key: DIALOG_KEY,
            fn: () => {
              backPressFn ? backPressFn() : cancelFn ? cancelFn() : void 0;
              this.hideDialog();
            }
          });
          this.countDownValue = countTime;
          if (countTime && countTime > 0 && textCountDown) {
            if (countDownIntearval) {
              clearInterval(countDownIntearval);
            }
            countDownIntearval = window.setInterval(() => {
              this.countDownValue--;
              if (this.countDownValue <= 0) {
                window.clearInterval(countDownIntearval);
                if (countDwonFn) {
                  countDwonFn();
                  this.hideDialog();
                }
              }
            }, 1000);
          }
        },
        computed: {
          renderMidContent() {
            return midContent === undefined
              ? ""
              : typeof midContent === "string"
              ? midContent
              : "";
          },
          renderTopContent() {
            return topContent === undefined
              ? ""
              : typeof topContent === "string"
              ? topContent
              : "";
          },
          title() {
            return title;
          },
          titleSmallClass() {
            return this.title.length > 22;
          },
          topIcon() {
            return topIcon ? topIcon : false;
          },
          buttons() {
            return buttons ? buttons : false;
          },
          topIconRadius() {
            return topIconRadius ? topIconRadius : 0;
          },
          textCountDown() {
            return textCountDown;
          },
          countTime() {
            return countTime ? countTime : false;
          },
          delayFn() {
            return delayFn ? delayFn : false;
          },
          size() {
            return size ? size : "";
          },
          closeImg() {
            return require("@/assets/icons-file/sku/icon_line_cancel.png");
          },
          closeImgShow() {
            return closeImgShow ? closeImgShow : false;
          },
          clock() {
            return clock ? clock : 0;
          },
          classId() {
            return classId;
          },
          countDwonFn() {
            return countDwonFn;
          }
        },
        template: `
        <div id="dialog-container" :class=[classId]>
        <div
          class="inner"
          :class="[size]"
          :style="{paddingBottom:buttons ?  buttons.length>1? '18px':'' : ''}"
          >
            
            <div class="dialog-icon" v-if="topIcon">
              <img class="main-img" :src="topIcon" :style="{borderRadius:topIconRadius + '%'}"/>
              <vip-clock v-if="clock > 0" :countTime="clock"/>
            </div>

            <div class="top-content" ref="topContent">
              <slot name="topContent"></slot>
              {{renderTopContent}}
            </div>
           
            <h2 :class="{small:titleSmallClass}">{{title}}</h2>

            <div class="mid-content" ref="midContent">
              <slot name="midContent"></slot>
              <div v-html="renderMidContent"></div>
            </div>

            <div class="button-wrappe">
              <div 
              class="button-item" 
              :style="{background:item.bgColor? item.bgColor: ''}"
              @click="clickButton(item)"
              v-for="(item,index) in buttons">
                <img 
                class="left-icon"
                v-if="item.leftIcon" 
                :src="item.leftIcon"/>
                <div v-if="item.uniqueButton" v-html="item.uniqueButton"></div>
                <div class="item_default_class" :style="{color:item.color? item.color: '',fontFamily:item.fontFamily? item.fontFamily: ''}" v-else>
                  {{item.text}}
                  <span v-if="textCountDown&&index==0">
                    ({{countDownValue}}s)
                  </span>
                </div>
                <div class="count-down-animation" v-if="!textCountDown&&countTime&&index==0">
                  <div 
                  :style="{animation:countTime+'ms scaleAuto linear'}"
                  class="count-down-animation-inner">
                  </div>
                </div>
              </div>
            </div>

            <div class="bottom-content" ref="bottomContent">
              <slot name="bottomContent"></slot>
            </div>
           
            <div
            class="close-btn"
            @click="clickColse"
            v-if="!closeImgShow"
           >
            <img
              :src="closeImg"
            />
            </div>
          </div>
          <div
            class="mask"
            @click="clickMask"
          />
        </div>
       `
      });
      instance = new dialogRef();
      if (generalUtilsHelper.isVnode(topContent)) {
        instance.$slots.topContent = topContent;
      }
      if (generalUtilsHelper.isVnode(midContent)) {
        instance.$slots.midContent = midContent;
      }
      if (generalUtilsHelper.isVnode(bottomContent)) {
        instance.$slots.bottomContent = bottomContent;
      }

      instance.$mount();

      if (generalUtilsHelper.isVueComponent(midContent)) {
        const el = midContent.$mount();
        const parent = instance.$refs.midContent;
        parent.appendChild(el.$el);
      }

      if (generalUtilsHelper.isVueComponent(topContent)) {
        const el = topContent.$mount();
        const parent = instance.$refs.topContent;
        parent.appendChild(el.$el);
      }

      if (generalUtilsHelper.isVueComponent(bottomContent)) {
        const el = bottomContent.$mount();
        const parent = instance.$refs.bottomContent;
        parent.appendChild(el.$el);
      }

      const root: any = document.getElementById("app");
      root.appendChild(instance.$el);

      //执行延迟函数：
      if (delayFn && countTime) {
        timer = setTimeout(() => {
          const el: any = document.getElementsByClassName(classId)[0];
          instance.$destroy();
          el && el.parentNode ? el.parentNode.removeChild(el) : null;
          delayFn();
        }, countTime);
      }

      console.log("dialog:", {
        instance,
        root
      });
    } catch (error) {
      console.error("error:", error);
      return Promise.reject(error);
    }
  },

  async [types.DIALOG_HIDE](
    { state, commit, dispatch, rootState },
    payLoad: any
  ) {
    const id = payLoad && payLoad.id;
    const classId = id ? "__classid__" + id : "dialog-container";
    const el: any = document.getElementsByClassName(classId)[0];
    // dom移除时会自动销毁组件实例？
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
      BakcPress.destroy(DIALOG_KEY);
    }
  },

  async [types.ACTOIN_SHEET_SHOW](
    { state, commit, dispatch, rootState },
    payLoad: any
  ) {
    try {
      console.log("ACTOIN_SHEET_SHOW payLoad:", payLoad);
      const { title, sheets } = payLoad;
      const actionRef: any = Vue.extend({
        methods: {
          hideActionSheet() {
            const el: any = document.getElementById("action-sheet");
            console.log("hideActionSheet el:", el);
            el && el.parentNode ? el.parentNode.removeChild(el) : null;
            BakcPress.destroy(ACTION_SHEET_KEY);
          },
          clickItem(sheet: any) {
            console.log("clickItem");
            sheet.Fn ? sheet.Fn() : null;
            this.hideActionSheet();
          }
        },
        mounted() {
          BakcPress.listen({
            key: ACTION_SHEET_KEY,
            fn: () => {
              this.hideActionSheet();
            }
          });
        },
        render() {
          return (
            <div id="action-sheet">
              <div class="mask" />
              <div class="action-content">
                <h2>{title}</h2>
                <div class="action-list">
                  <ul>
                    {sheets.map((sheet: any) => {
                      return (
                        <li
                          onClick={() => {
                            this.clickItem(sheet);
                          }}
                        >
                          <h3
                            style={{
                              color: sheet.textColor ? sheet.textColor : null
                            }}
                          >
                            {sheet.text}
                          </h3>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          );
        }
      });
      const instance = new actionRef().$mount();
      const root: any = document.getElementById("app");
      root.appendChild(instance.$el);
    } catch (error) {
      console.log("ACTOIN_SHEET_SHOW error:", error);
    }
  },

  // 传入参数： 按钮， 获奖的数量, 以及是否是最高奖
  async [types.CASINO_DIALOG_SHOW](
    { state, commit, dispatch, rootState },
    payLoad: any
  ) {
    try {
      console.log("CASINO_DIALOG_SHOW payLoad:", payLoad);
      const {
        midContent,
        buttons,
        cancelFn,
        countTime,
        delayFn,
        closeImgShow, //关闭的按钮图片是否显示
        backPressFn,
        win,
        number,
        highest_reward
      } = payLoad;
      let instance: any;
      let timer: any;
      const dialogRef: any = Vue.extend({
        methods: {
          hideDialog() {
            const el: any = document.getElementById("dialog_container_lottery");
            instance.$destroy();
            console.log("dialog-dialog_container_lottery el:", el);
            el && el.parentNode ? el.parentNode.removeChild(el) : null;
            clearTimeout(timer);
            BakcPress.destroy(DIALOG_KEY);
          },
          clickMask() {
            if (this.closeImgShow === false) {
              return;
            }
            this.hideDialog();
            cancelFn === undefined ? null : cancelFn();
          },
          clickColse() {
            this.hideDialog();
            cancelFn === undefined ? null : cancelFn();
          },
          clickButton(button: any) {
            // 如果没传函数进来默认关闭dialog，传了需要调用callback关闭dialog(hideDialog)
            button.clickFn === undefined
              ? this.hideDialog()
              : button.clickFn(this.hideDialog);
          }
        },
        mounted() {
          BakcPress.listen({
            key: DIALOG_KEY,
            fn: () => {
              backPressFn ? backPressFn() : cancelFn ? cancelFn() : void 0;
              this.hideDialog();
            }
          });
        },
        computed: {
          renderMidContent() {
            return midContent === undefined
              ? ""
              : typeof midContent === "string"
              ? midContent
              : "";
          },
          topIcon() {
            return number
              ? highest_reward
                ? remoteImg("/lottery/winMore.png")
                : remoteImg("/lottery/win.png")
              : remoteImg("/lottery/try_again.png");
          },
          buttons() {
            return buttons ? buttons : false;
          },
          win() {
            return win ? win : false;
          },
          unit_icon() {
            return number
              ? require("@/assets/icons-file/sku/coins.png")
              : require("@/assets/icons-file/lottery/watch.png");
          },
          content() {
            return number ? "Coins" : "Free Chance";
          },
          number() {
            return number ? number : false;
          },
          highest_reward() {
            return highest_reward ? highest_reward : false;
          },
          countTime() {
            return countTime ? countTime : false;
          },
          delayFn() {
            return delayFn ? delayFn : false;
          },
          closeImg() {
            return require("@/assets/icons-file/sku/icon_line_cancel.png");
          },
          star() {
            return remoteImg("/lottery/star2.png");
          },
          closeImgShow() {
            return closeImgShow ? closeImgShow : false;
          },
          light() {
            return remoteImg("/lottery/light.png");
          },
          purplelight() {
            return remoteImg("/lottery/purplelight.png");
          },
          freechance() {
            return remoteImg("/lottery/freechance.png");
          },
          watch_icon() {
            return remoteImg("/lottery/ads.png");
          }
        },
        template: `
        <div id="dialog_container_lottery">
        <div
          class="inner"
          :style="{paddingBottom:buttons ?  buttons.length>1? '18px':'' : ''}"
          >
            <img :class="{bottomChange: highest_reward}" class="topIcon" :src = "topIcon"/>
            <section class="dialog_content">
              <img class="light" :src = "light"/>
              <!--<img class="purplelight" :src = "purplelight"/>-->
              <div class="dialog_inner">
                <img v-if="highest_reward" :src = "star" class="star"/>
                <img class="purplelight" :src = "purplelight"/>
                 <img v-if="!number" class="free" :src = "freechance"/>
                 <p v-if="number" class="number">{{number}}</p>
                 <div class="unit">
                  <img class="unit_icon" :src="unit_icon"/>
                  <p class="unit_text">{{content}}</p>
                  </div>
              </div>
              <div class="coins"></div>
            </section>
            <div class="button-wrappe">
              <div 
              class="button-item" :class="{single: buttons.length === 1}"
              :style="{background:item.bgColor? item.bgColor: '',color:item.color? item.color: '',fontFamily:item.fontFamily? item.fontFamily: ''}"
              @click="clickButton(item)"
              v-for="(item,index) in buttons">
                <img v-if="buttons.length !== 1 && index === 0" class="watch_icon" :src="watch_icon"/>
                <p>{{item.text}}</p>
                <div class="count-down-animation" v-if="countTime&&index==0">
                      <div 
                      :style="{animation:countTime+'ms scaleAuto linear'}"
                      class="count-down-animation-inner">
                      </div>
                    </div>
              </div>
            </div>
          </div>
          <div
            class="mask"
            @click="clickMask"
          />
        </div>
       `
      });
      instance = new dialogRef();
      if (generalUtilsHelper.isVnode(midContent)) {
        instance.$slots.midContent = midContent;
      }

      instance.$mount();

      if (generalUtilsHelper.isVueComponent(midContent)) {
        const el = midContent.$mount();
        const parent = instance.$refs.midContent;
        parent.appendChild(el.$el);
      }

      const root: any = document.getElementById("app");
      root.appendChild(instance.$el);

      //执行延迟函数：
      if (delayFn && countTime) {
        timer = setTimeout(() => {
          const el: any = document.getElementById("dialog_container_lottery");
          instance.$destroy();
          el && el.parentNode ? el.parentNode.removeChild(el) : null;
          delayFn();
        }, countTime);
      }

      console.log("dialog:", {
        instance,
        root
      });
    } catch (error) {
      console.error("error:", error);
      return Promise.reject(error);
    }
  },

  // 封装弹窗,传入弹窗对象  传入奖励的数量，是否可以加倍，是否是当前最高的奖励
  async [types.CASINO_DIALOG_USE](
    { state, commit, dispatch, rootState },
    payLoad: any
  ) {
    try {
      console.log("CASINO_DIALOG_USE", payLoad);
      const {
        reward,
        highest_reward,
        double,
        func,
        funcSupply,
        backPressFn
      } = payLoad;
      const buttons = [
        {
          text: reward ? (double ? "DOUBLE x2" : "COLLECT") : "EXTRA CHANCE",
          clickFn: func
        }
      ];
      if (double || !reward) {
        buttons.push({
          text: reward ? "COLLECT" : "IGNORE",
          clickFn: funcSupply
        });
      }
      const obj = { number: reward, highest_reward, buttons, backPressFn };
      console.log("dialogObj", obj);
      dispatch(types.CASINO_DIALOG_SHOW, obj);
    } catch (e) {}
  },

  async [types.DIALOG_SHOW_LOGIN_REQUIRED](
    { state, commit, dispatch, rootState, getters },
    payLoad: any
  ) {
    try {
      const userList = getters[types.GETTER_USER_LIST];

      const findUser = userList.find((user: any) => {
        return user.userId === payLoad;
      });

      if (findUser) {
        dispatch(types.DIALOG_SHOW, {
          title: "Login Required",
          topContent: dialogTopContent(findUser.userPic, "loginRequired"),
          midContent: `Dear @${findUser.userName}, your account has expired, please login again.`,
          buttons: [
            {
              text: "I AGREE",
              clickFn: () => {
                dispatch(types.ROUTER_PUSH, {
                  name: "Login",
                  params: {
                    routerTransition: "up"
                  }
                });
              }
            }
          ],
          cancelFn: () => {}
        });
      }
    } catch (e) {}
  },

  async [types.DIALOG_SHOW_NEWBIE_FREE_FOLLOW](
    { state, commit, dispatch, rootState },
    payLoad: any
  ) {
    try {
      console.log("DIALOG_SHOW_NEWBIE_FREE_FOLLOW", payLoad);
      const { loginCallback, giveupCallback, fromPage } = payLoad;

      const okFn = () => {
        if (loginCallback) {
          loginCallback();
        }
        dispatch(types.ROUTER_PUSH, {
          name: "Login",
          params: {
            routerTransition: "up",
            from: fromPage ? fromPage : "none"
          },
          query: {
            from: fromPage ? fromPage : "none"
          }
        });
      };
      dispatch(types.DIALOG_SHOW, {
        title: "Login Required",
        topIcon: require("@/assets/icons-file/followers/pic_pop_loginrequired@3x.png"),
        midContent: `To get this <i>FREE followers reward</i>, <i>log in</i> to your Instagram account first.`,
        textCountDown: true,
        countDwonFn: okFn,
        countTime: 5,
        buttons: [
          {
            text: "LOG IN",
            clickFn: () => {
              okFn();
            }
          },
          {
            text: "GIVE UP",
            clickFn: () => {
              if (giveupCallback) {
                giveupCallback();
              }
            }
          }
        ],
        closeImgShow: true
      });
    } catch (e) {}
  }
};

export default actions;
